// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const AvailableoutlinedSm = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M8 15.5C3.85787 15.5 0.5 12.1422 0.5 8C0.5 3.85787 3.85787 0.5 8 0.5C12.1422 0.5 15.5 3.85787 15.5 8C15.5 12.1422 12.1422 15.5 8 15.5Z" stroke={color} />
        <path d="M5 8.28571L6.8 10L11 6" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
